export default "__VITE_ASSET__ByCKrFp8__"